import React from "react"
import { motion, AnimatePresence } from "services/framerMotion"
import { useModal } from "hooks/useModal"
import { useTranslation } from "react-i18next"

import { CrossIcon } from "components/Elements/Icons"

import "./Modal.scoped.scss"

export const ModalOverlayVariants = {
    open: {
        opacity: "0.6",
        transition: {
            when: "beforeChildren"
        }
    },
    closed: {
        opacity: "0",
        transition: {
            when: "afterChildren"
        },
    }
}

export const ModalVariants = {
    open: {
        opacity: "1",
        y: "0",
    },
    closed: {
        opacity: "0",
        y: "50%",
    }
}

const Modal = (
    { 
        children, 
        onClose, 
        modalClassName, 
        authorizedClosingModal = true,
        ...props 
    }
) => {
    const { t } = useTranslation()
    return (
        <AnimatePresence>
            {children && (
                <motion.div
                    key="modal-wrapper"
                    className="c-modal-wrapper"
                >
                    {authorizedClosingModal && 
                        <motion.div className={"c-modal-overlay"}
                            key="modal-overlay"
                            onClick={onClose}
                            initial="closed"
                            animate="open"
                            exit="closed"
                            variants={ModalOverlayVariants}>
                        </motion.div>
                    }

                    {!authorizedClosingModal && 
                        <div className={"c-modal-overlay c-modal-overlay--light"}></div>
                    }

                    <motion.div className={"c-modal " + (modalClassName ? modalClassName : "")}
                        {...props}
                        key="modal"
                        onClick={e => e.stopPropagation()}
                        initial="closed"
                        animate="open"
                        exit="closed"
                        variants={ModalVariants}
                    >
                        {authorizedClosingModal &&
                            <button onClick={onClose} aria-label={t("menu.close")} className="c-modal__close u-pd-xs">
                                <CrossIcon size={25} />
                                <span className="mt-1 text-xxs">
                                    {t("global.close")}
                                </span>
                            </button>
                        }

                        {children}
                    </motion.div>
                </motion.div>
            )}
         </AnimatePresence>
    )
}

const ModalRoot = () => {
    const { component, modalProps, hideModal } = useModal()
    return (
        <Modal onClose={hideModal} {...modalProps}>
            { component }
        </Modal>
    )
}


export { Modal as default, ModalRoot }
